module.exports = __webpack_public_path__ + "static/media/UC_Davis_logo.10464c52.png";